export function extend(base: string, extension?: string) {
	return `${base}${extension ? ' ' + extension : ''}`;
}
